import gql from 'graphql-tag'

export default gql`
  mutation createSubscription($subscriptionPriceId: String!, $users: [StripeUserInput]!) {
    createSubscription(subscriptionPriceId: $subscriptionPriceId, users: $users) {
      success
      message
      totalSeats
      clientSecret
      subscriptionId
      isFirstSubscription
      eligibleForTrial
    }
  }
`
